import { LinkButton } from "components/Common/Link";
import PlaceOrderOriginalOrderDetails from "components/Common/PlaceOrderOriginalOrderDetails/PlaceOrderOriginalOrderDetails";
import AddGlobalAttributes from "components/NewOrders/AddGlobalAttributes/AddGlobalAttributes";
import GlobalFormProvider from "components/NewOrders/AddGlobalAttributes/forms/GlobalFormProvider";
import ImportCSV from "components/NewOrders/ImportCSV/ImportCSV";
import {
	AddOnEnterOrder,
	AddOnsDesktopBanner,
	AddOnsHeaderContainer,
	AddOnsLandingPageEnterOrderContainer,
	AddOnsMobileBanner,
	AddOnsTabletBanner,
	DraftNewOrderHeader,
	ManualOrderEntryAddOn,
	OrderOrAddOnText,
	UnsetSecondaryCopy
} from "components/NewOrders/NewOrders.styles";
import { AddOnsBannerAltText } from "components/NewOrders/constants";
import {
	BuildYourOrderText,
	CreateYourItemSubtitleText,
	LowesOrderAddOns,
	ManualOrderEntryText,
	OrderAddOns,
	ReturnToOriginalOrderText
} from "constants/text";
import { newOrderActions } from "features/reducers/newOrder/newOrder";
import useInitOrderDetail from "hooks/useInitOrderDetail";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { useGetUserDetailsQuery } from "features/api/userApi.ts";
import { UserChannel } from "types/declarations/enums.ts";
import { cartActions } from "features/reducers/replacementOrder/cart.ts";
import { Page } from "components/Common/Page";

const AddOnLandingPage = () => {
	const params = useParams();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const { orderDetail, orderId } = useInitOrderDetail(params.orderId);
	const { data: userDetails } = useGetUserDetailsQuery();

	const isLowesUser = userDetails?.userChannel === UserChannel.LOWES;

	useEffect(() => {
		dispatch(newOrderActions.clearNewOrder());
		dispatch(newOrderActions.resetNewOrderFlow());
		dispatch(cartActions.resetCart());
	}, [dispatch, orderId]);
	return (
		<Page variant="orders">
			<AddOnsHeaderContainer variant="panel">
				<div data-testid="add-ons-header-return-to-original-order">
					<LinkButton
						hasBackIcon
						onClick={() => navigate(`/details/${orderId}`)}
						data-testid="add-ons-return-to-original-order-link"
					>
						{ReturnToOriginalOrderText}
					</LinkButton>
				</div>
				<h1>{isLowesUser ? LowesOrderAddOns : OrderAddOns}</h1>
				<PlaceOrderOriginalOrderDetails
					orderDetail={orderDetail}
					isAddOnLandingPage
				/>
			</AddOnsHeaderContainer>
			<AddOnsLandingPageEnterOrderContainer>
				<AddOnsDesktopBanner
					src="/assets/welcome_banners/DesktopAnnouncementBanner_AddOn.svg"
					alt={AddOnsBannerAltText}
				/>
				<AddOnsTabletBanner
					src="/assets/welcome_banners/TabletAnnouncementBanner_AddOn.svg"
					alt={AddOnsBannerAltText}
				/>
				<AddOnsMobileBanner
					src="/assets/welcome_banners/MobileAnnouncementBanner_AddOn.svg"
					alt={AddOnsBannerAltText}
				/>
				<DraftNewOrderHeader>{BuildYourOrderText}</DraftNewOrderHeader>
				<AddOnEnterOrder>
					<ImportCSV isAddOn />
					<ManualOrderEntryAddOn>
						<OrderOrAddOnText>{ManualOrderEntryText}</OrderOrAddOnText>
						<UnsetSecondaryCopy>{CreateYourItemSubtitleText}</UnsetSecondaryCopy>
						<GlobalFormProvider>
							<AddGlobalAttributes
								showAddItem
								isAddOn
								isCustomColor={false}
							/>
						</GlobalFormProvider>
					</ManualOrderEntryAddOn>
				</AddOnEnterOrder>
			</AddOnsLandingPageEnterOrderContainer>
		</Page>
	);
};

export default AddOnLandingPage;
